<template>
    <div class="d-flex flex-row">
        <div class="add-btn position-relative">
            <b-button variant="light" class="text-nowrap m-1" @click="addNewRow">
                {{ label }}
                <b-icon icon="plus"></b-icon>
            </b-button>
            <b-avatar size="12" variant="danger" icon="x-lg" button class="avatar-cover"
                      @click="$emit('delete')"></b-avatar>
        </div>
        <div class="d-flex flex-column col">
            <template v-for="(row, index) of currentRows">
                <div :key="index" class="w-100">
                    <mini-form-input v-if="isInput"
                                     class="w-100 mb-1"
                                     :value.sync="currentRows[index]"
                                     no-label
                                     :width-px="[100,210]"
                                     :type="config"
                                     horizontal
                                     @delete="whenDelete(index)"></mini-form-input>
                    <json-input-object v-else
                                       class="w-100 mb-1"
                                       :ref="`Ref${index}`"
                                       :config="config"
                                       :label="`No.${index + 1}`"
                                       :value.sync="currentRows[index]"
                                       @delete="whenDelete(index)"></json-input-object>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import MiniFormInput from "@/views/report/jsonEdit/MiniFormInput";

export default {
    name: "JsonInputArray",
    components: {JsonInputObject: () => import('@/views/report/jsonEdit/JsonInputObject'), MiniFormInput},
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            require: true
        },
        config: {
            type: [Array, String],
            default: () => []
        },
        label: {
            type: String,
            default: 'One More',
        }
    },
    computed: {
        isInput() {
            return typeof this.config === 'string';
        },
    },
    watch: {
        currentRows: {
            handler() {
                this.$emit('update:value', this.currentRows);
            },
            deep: true,
        },
        value: {
            handler() {
                this.currentRows = this.value;
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            currentRows: []
        }
    },
    methods: {
        addNewRow() {
            this.currentRows.push(this.isInput ? '' : {});
        },
        whenDelete(index) {
            this.$delete(this.currentRows, index);
        },
    },
}
</script>

<style scoped>
.add-btn {
    height: max-content;
}

.add-btn:hover .avatar-cover {
    opacity: 1;
}

.avatar-cover {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    z-index: 99;
    transition: opacity ease-out .3s;
}

.avatar-cover:hover {
    opacity: 1;
}
</style>